export default "__VITE_ASSET__cDDWnwVJ__"